const AccordionDetails = document.querySelectorAll(".accordion_details");
const AccordionSummary = document.querySelectorAll(".accordion_summary");
const AccordionPanels = document.querySelectorAll(".accordion_panel");

const animTiming = {
  duration: 300,
  easing: "ease-in-out",
};

const closingAnimation = (panel) => [
  {
    height: panel.offsetHeight + "px",
    opacity: 1,
  },
  {
    height: 0,
    opacity: 0,
  },
];

const openingAnimation = (panel) => [
  {
    height: 0,
    opacity: 0,
  },
  {
    height: panel.offsetHeight + "px",
    opacity: 1,
  },
];

AccordionDetails.forEach(function (e, index) {
  const summary = AccordionSummary[index];
  const panel = AccordionPanels[index];

  summary.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", (event) => {
      event.stopPropagation();
    });
  });
  
  summary.addEventListener("click", (event) => {
    event.preventDefault();
    if (e.getAttribute("open") !== null) {
      e.classList.remove("is_open");
      const closingAnim = panel.animate(closingAnimation(panel), animTiming);
      closingAnim.onfinish = () => {
        e.removeAttribute("open");
      };
    } else {
      e.setAttribute("open", "true");
      const openingAnim = panel.animate(openingAnimation(panel), animTiming);
      e.classList.add("is_open");
    }
  });
});
